<div
  class="body ui container"
  fxLayout="column"
  style="margin: 0; border: none !important; width: 100%"
>
  <div
    class="ui divider"
    appMargin
    marginY="3"
    style="border: none !important"
  ></div>
  <div *ngIf="success || error">
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <app-advanced-search-filter
    (onDisplayRows)="displayRecords($event)"
    (onSearch)="searchRecords($event)"
    [hasAdvancedSearch]="true"
    [headers]="headers"
    [headerFilters]="headerFilters"
    [hasFilters]="true"
    (onSort)="sortRecords($event)"
    [searchFilters]="searchFilter"
    (advancedSearch)="advancedSearch($event)"
    (cancelAd)="cancelAd()"
  ></app-advanced-search-filter>

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="15px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <div fxFlex="10%">IP Address</div>
      <div fxFlex="20%">Host Name</div>
      <div fxFlex="10%">Status Code</div>
      <div fxFlex="20%">Description</div>
      <div fxFlex="20%">Username</div>
      <div fxFlex="15%">Timestamp</div>
    </div>

    <div
      class="ui attached segment"
      appMargin
      marginT="5"
      *ngFor="let rateLimit of rateLimits"
    >
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <div fxFlex="10%">
          {{ rateLimit?.metaData?.ipAddress }}
        </div>
        <div fxFlex="20%">
          {{ rateLimit?.metaData?.hostName }}
        </div>
        <div fxFlex="10%">
          {{ rateLimit?.metaData?.statusCode }}
        </div>
        <div fxFlex="20%">
          {{ rateLimit?.eventDescription }}
        </div>
        <div fxFlex="20%">
          {{ rateLimit?.metaData?.username }}
        </div>
        <div fxFlex="15%">
          {{ rateLimit?.dateCreated | date: "d, MMMM y, h:mma" }}
        </div>
      </div>
    </div>

    <app-no-record-found *ngIf="!rateLimits.length"></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
